export default "__VITE_ASSET__VuzK1sjn__"